import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { FactFamilyOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * How a fact family is asked: write the four equations, fill a number bond, or
 * find the missing part in words. The operator bar above chooses additive or
 * multiplicative families (or both). See ADR 0020.
 */
export function FactFamilySettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleChange(value: FactFamilyOptions) {
        if (!value) return;
        setSettings({ ...settings, FactFamilyQuestion: value });
    }

    return (
        <div className="factFamilyContainer">
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.questionLabel')}</span>
            </div>
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.FactFamilyQuestion}
                    onChange={(e) => handleChange(e.value)}
                    options={withLabels(Object.values(FactFamilyOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.factFamilyQuestionAria')}
                />
            </div>
        </div>
    );
}

export default FactFamilySettings;
